module.exports = __webpack_public_path__ + "media/images/athletes/493-7616b0a2fd17d676a7bc28b95f4af36c.png";